import { createReducer, createSelector, on } from "@ngrx/store";
import { loadGridStateSuccess } from "./bryntum-grid-state.actions";

export interface IBryntumGridState {
    gridState: { gridType: number, state: any }[];
}

export const initialBryntumGridState: IBryntumGridState = {
    gridState: []
};

export const bryntumGridReducer = createReducer(
    initialBryntumGridState,
    // Add action handlers here
    on(loadGridStateSuccess, (state, action) => {
        return {
            ...state,
            gridState: [
                ...state.gridState.filter((gridState) => gridState.gridType !== action.bryntumComponentTypeId),
                {
                    gridType: action.bryntumComponentTypeId,
                    state: action.state
                }
            ]
        }
    }),
)

export const selectBryntumGridState = (state: any): IBryntumGridState => state.BryntumGridState;

export const selectGridStateById = (props: { bryntumComponentTypeId: number }) => {
    return createSelector(selectBryntumGridState, (state) => {
        return state.gridState.find((gridState: any) => gridState.gridType === props.bryntumComponentTypeId)
    });
};